// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"a8add5ba","448":"b9b68db8","453":"34bc8f3b"}[chunkId] + ".chunk.js";
};